type TiptapViewerSkeletonProps = {
  minHeight?: number;
};

export function TiptapViewerSkeleton({ minHeight = 192 }: TiptapViewerSkeletonProps) {
  return (
    <div className="flex flex-col gap-3" style={{ minHeight }} aria-hidden>
      <div className="skeleton h-5 w-2/5 rounded" />
      <div className="skeleton h-4 w-full rounded" />
      <div className="skeleton h-4 w-11/12 rounded" />
      <div className="skeleton h-4 w-4/5 rounded" />
      <div className="skeleton h-24 w-full rounded-xl" />
      <div className="skeleton h-4 w-full rounded" />
      <div className="skeleton h-4 w-3/4 rounded" />
    </div>
  );
}
